import { useAppUserAccess } from 'global/cnr/contexts/useHelpers/useAppUserAccess'
import _ from 'lodash'
import { useContext, useEffect, useState } from 'react'
import { Button, Icon, Label } from 'semantic-ui-react'
import { ParentContext } from '../../../../global/cnr/contexts/ParentContext'
import { gEnums } from '../../../../global/enums/globalEnums'
import { SeasonMatchesContext } from '../../cnr/contexts/SeasonMatchesContext'
import { SportsMatchContext } from '../../cnr/contexts/SportsMatchContext'
import { SportsRtMatchContext } from '../../cnr/contexts/SportsRtMatchContext'
import { matchScheduleTypes, SportsSeasonContext } from '../../cnr/contexts/SportsSeasonContext'
import MatchPointScoring from './MatchPointScoring'
import MatchScoreKeypad, { _keypadTypes } from './MatchScoreKeypad'
import { useRealtimeUpdate } from 'projectSpecific/sports/useHelpers/useRealtimeUpdate'

const WAIT_INTERVAL = 1000
const useStats = false

const _matchScoreModes = {
  normal: 'normal',
  showMatchAmmend: 'showMatchAmmend',
  showConfirmRemove: 'showConfirmRemove',
  showConfirmMatch: 'showConfirmMatch',
  showConfirmSet: 'showConfirmSet',
  showKeyPad: 'showKeyPad',
  showTracker: 'showTracker',
}

const _cn_grp = 'match-score-grpup'
const _cn_btn = 'match-score-btns'

const MatchScoreButtons = () => {

  const parentContext = useContext(ParentContext)
  const { fns } = parentContext ?? {}
  const _appUserAccess = useAppUserAccess()
  const { displayName } = _appUserAccess
  const { appUser_fns } = fns
  const accessLevel = appUser_fns.get_accessLevel()
  const allowMatchEdit = accessLevel >= gEnums.accessLevels.superAdmin.value

  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state, sportsSeason_handlers } = sportsSeasonContext
  const { sportDataSettings } = sportsSeason_state ?? {}
  const { useRtGameDayData } = sportDataSettings ?? {}

  // seasonMatchesContext
  const seasonMatchesContext = useContext(SeasonMatchesContext)
  const { seasonMatches_state, seasonMatches_handlers } = seasonMatchesContext ?? {}
  const { matchScheduleType } = seasonMatches_state ?? {}

  // sportsMatchContext
  const sportsMatchContext = useContext(SportsMatchContext)
  const { sportsMatch_handlers, sportsMatch_state } = sportsMatchContext ?? {}
  const { match_true, sportPermissions } = sportsMatch_state ?? {}

  // sportsRtMatchContext
  const sportsRtMatchContext = useContext(SportsRtMatchContext)
  const { sportsRtMatch_state, sportsRtMatch_handlers } = sportsRtMatchContext ?? {}
  const { match_rt } = sportsRtMatch_state ?? {}
  const { away, home, _results } = match_rt ?? {}
  const { setNumber, set_complete_possible, match_complete_possible } = _results ?? {}

  const showSetEnd = set_complete_possible && !match_complete_possible
  const showMatchEnd = match_complete_possible
  const showEnds = showSetEnd || showMatchEnd

  const [restrictAccess, setRestrictAccess] = useState()
  const [matchScoreMode, setMatchScoreMode] = useState(_matchScoreModes.normal)
  const [showStats, setShowStats] = useState()

  const { updateMatchScore_realtime } = useRealtimeUpdate()

  const _allowRemoveRts = sportPermissions && sportPermissions.any && sportPermissions.rtMatches ? true : false

  useEffect(() => {
    if (restrictAccess) {
      const timer = setTimeout(() => setRestrictAccess(false), WAIT_INTERVAL);
      return () => clearTimeout(timer);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [restrictAccess]);

  useEffect(() => {
    if (!match_rt && sportsRtMatch_handlers) {
      sportsRtMatch_handlers.handleSet_rtMatch(match_true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleStopProp = (e) => {
    e.stopPropagation()
  }

  const handleConfirm = (ss, selectedStat) => {
    const { rtType, add } = ss
    setShowStats()
    setRestrictAccess(true)
    if (selectedStat) {
      !restrictAccess && updateMatchScore_realtime({ match_true, match_rt, rtType, add, selectedStat })
    } else {
      !restrictAccess && updateMatchScore_realtime({ match_true, match_rt, rtType, add })
    }
  }

  const handleRtUpdate_score = (e, rtType, add) => {
    e.stopPropagation()
    if (useStats && allowMatchEdit) {
      setShowStats({ rtType, add })
    } else {
      setRestrictAccess(true)
      updateMatchScore_realtime({ match_true, match_rt, rtType, add })
    }
  }

  const handleRtConfirm_set = (e) => {
    e.stopPropagation()
    setRestrictAccess(true)
    updateMatchScore_realtime({ match_true, match_rt, rtType: 'set' })
  }

  const handleMatchScoreMode = (e, sms) => {
    e.stopPropagation()
    setMatchScoreMode(sms ? sms : _matchScoreModes.normal)
  }

  const handleRemoveRtMatch = (e) => {
    e.stopPropagation()
    setRestrictAccess(true)
    setMatchScoreMode(_matchScoreModes.normal)
    sportsRtMatch_handlers.handleRtDelete_scores()
    seasonMatches_handlers.handleSelect_currentMatch()
  }

  const handle_updateResults_match = (e) => {
    e.stopPropagation()
    const cb = () => {
      setMatchScoreMode(_matchScoreModes.normal)
      // sportsSeason_handlers.handleUpdate_sportsSeasonTs()
      // sportsRtMatch_handlers.handleRtDelete_scores()
      // seasonMatches_handlers.handleSelect_currentMatch()
    }
    !restrictAccess && updateMatchScore_realtime({ match_true, match_rt, rtType: 'match' })
  }

  const handleScoreClose = (e) => {
    e.stopPropagation()
    seasonMatches_handlers.handleSelect_currentMatch()
  }

  const rtScores = {
    home: 0,
    away: 0,
    setNumber: 0
  }

  if (match_rt) {

    const { _results } = match_rt ?? {}
    const { scores } = _results ?? {}

    if (scores) {
      delete scores[0]
      _.forEach(scores, (_score, setNumber) => {
        if (_score.home || _.isNumber(_score.home)) {
          rtScores.home = {
            score: _score.home,
            color: _score.home > _score.away ? 'green' : _score.home < _score.away ? 'red' : 'blue',
            cn: _score.home > _score.away ? 'up' : _score.home < _score.away ? 'down' : 'tie'
          }
          rtScores.setNumber = setNumber
        }
        if (_score.away || _.isNumber(_score.away)) {
          rtScores.away = {
            score: _score.away,
            color: _score.away > _score.home ? 'green' : _score.away < _score.home ? 'red' : 'blue',
            cn: _score.away > _score.home ? 'up' : _score.away < _score.home ? 'down' : 'tie'
          }
          rtScores.setNumber = setNumber
        }
      })
    }
  }

  const content_remove = (e) => <div className={_cn_btn + ' rmv'}>
    <Button.Group size='mini' fluid >
      <Button icon='delete' color={'grey'} onClick={(e) => { handleMatchScoreMode(e, _matchScoreModes.showMatchAmmend) }} />
      <Button color={_allowRemoveRts ? 'red' : 'grey'} fluid onClick={(e) => { handleRemoveRtMatch(e) }} >{'Confirm Remove RTS'}</Button>
    </Button.Group>
  </div>

  const content_possibleConfirm_set = (e) => <div className={_cn_btn + ' rmv'}>
    <Button.Group size='mini' fluid >
      <Button icon='delete' color={'grey'} onClick={(e) => { handleMatchScoreMode(e, _matchScoreModes.normal) }} />
      <Button color={'blue'} disabled={!set_complete_possible} onClick={(e) => { handleMatchScoreMode(e, _matchScoreModes.showConfirmSet) }} >{'Confirm Set ' + setNumber}</Button>
    </Button.Group>
  </div>

  const content_confirm_set = (e) => <div className={_cn_btn + ' rmv'}>
    <Button.Group size='mini' fluid >
      <Button icon='delete' color={'grey'} onClick={(e) => { handleMatchScoreMode(e, _matchScoreModes.normal) }} />
      <Button color={'green'} fluid onClick={(e) => { handleRtConfirm_set(e) }} >{useRtGameDayData ? 'Confirm Set Result RT' : 'Confirm Set Result'}</Button>
    </Button.Group>
  </div>

  const content_confirm_match = (e) => <div className={_cn_btn + ' rmv'}>
    <Button.Group size='mini' fluid >
      <Button icon='delete' color={'grey'} onClick={(e) => { handleMatchScoreMode(e, _matchScoreModes.normal) }} />
      <Button color={'green'} fluid onClick={(e) => { handle_updateResults_match(e) }} >{useRtGameDayData ? 'Confirm Match Result RT' : 'Confirm Match Result'}</Button>
    </Button.Group>
  </div>

  /**
   * 
   * @param {*} e 
   * @returns a group of buttons to modify the result
   */
  const content_ammend = (e) => {

    return <div className={_cn_grp + ' amd'} onClick={(e) => { handleMatchScoreMode(e, _matchScoreModes.normal) }}>
      <Button.Group size='mini' fluid >
        <Button icon='arrow left' color={'black'} onClick={(e) => { handleMatchScoreMode(e, _matchScoreModes.normal) }} />
        <Button icon='delete' color={'grey'} onClick={(e) => { handleScoreClose(e) }} />
        <Button color={'blue'} onClick={(e) => { handleMatchScoreMode(e, _matchScoreModes.showConfirmRemove) }} >{'Remove RTS'}</Button>
        {showSetEnd && content_possibleConfirm_set()}
        {showMatchEnd && <Button color={'blue'} disabled={!match_complete_possible} onClick={(e) => { handleMatchScoreMode(e, _matchScoreModes.showConfirmMatch) }} >{'Confirm Match'}</Button>}
        <Button icon='keyboard outline' color={'blue'} onClick={(e) => { handleMatchScoreMode(e, _matchScoreModes.showKeyPad) }} />
      </Button.Group>
    </div>
  }

  /**
   * 
   * @param {object} score 
   * @param {object} team 
   * @param {object} t 
   * @returns 
   */
  const teamSetScoreButtons = (score, team, t) => {
    let cn = matchScheduleType === matchScheduleTypes.latest ? 'team-score-' + t : t
    return <Button.Group size='mini' >
      {!showEnds && <Button icon='arrow left' color={!restrictAccess ? 'red' : 'grey'} onClick={(e) => { handleRtUpdate_score(e, team, false) }} />}
      <Button content={score.score} className={cn} color='black' />
      {!showEnds && <Button icon='arrow right' color={!restrictAccess ? 'green' : 'grey'} onClick={(e) => { handleRtUpdate_score(e, team, true) }} />}
    </Button.Group>
  }

  // handleSelect_currentMatch
  const content_teams = () => {
    return <div className='match-score-teams'>
      <div>{away?.name}</div>
      <Label onClick={(e) => { handleScoreClose(e) }} color='black' size='tiny'>{'Realtime Scoring'}<Icon name='delete' /></Label>
      <div>{home?.name}</div>
    </div>
  }
  /**
   * 
   * @returns a group of buttons to update the score
   */
  const content_scoring_rt = () => {
    let cn = _cn_btn
    if (showEnds) {
      cn += ' cfm'
    }

    return <div className={cn} onClick={(e) => { handleStopProp(e) }}>
      {teamSetScoreButtons(rtScores.away, 'away', 'away ' + rtScores.away.cn)}
      <div>
        {/* {!showEnds && <Icon bordered name='caret down' color='blue' onClick={(e) => { handleMatchScoreMode(e, _matchScoreModes.showTracker) }} />} */}
        {allowMatchEdit && !set_complete_possible && !match_complete_possible && <Icon bordered name='tasks' color='blue' onClick={(e) => { handleMatchScoreMode(e, _matchScoreModes.showMatchAmmend) }} />}
        {allowMatchEdit && set_complete_possible && !match_complete_possible && content_possibleConfirm_set()}
        {allowMatchEdit && match_complete_possible && <Button size={'mini'} color={'blue'} disabled={!set_complete_possible} onClick={(e) => { handleMatchScoreMode(e, _matchScoreModes.showConfirmMatch) }} >{'Confirm Match'}</Button>}
      </div >
      {teamSetScoreButtons(rtScores.home, 'home', 'home ' + rtScores.home.cn)}
    </div >
  }

  const matchKeypad = () => <div className={_cn_btn + '  kpd'} >
    <MatchScoreKeypad keypadType={_keypadTypes.realtime} handleClose={handleMatchScoreMode} />
  </div>

  const content_match = (content) => {
    return <div className='match-score-content btns'>
      {content_teams()}
      {<div className='match-score-set'>{'Set: ' + setNumber}</div>}
      {content}
    </div>
  }

  if (showStats) {
    return content_match(<MatchPointScoring showStats={showStats} home={home} away={away} handleConfirm={handleConfirm} />)
  } else {
    switch (matchScoreMode) {
      case _matchScoreModes.showConfirmSet:
        return content_match(content_confirm_set())
      case _matchScoreModes.showConfirmMatch:
        return content_match(content_confirm_match())
      case _matchScoreModes.showConfirmRemove:
        return content_match(content_remove())
      case _matchScoreModes.showKeyPad:
        return content_match(matchKeypad())
      case _matchScoreModes.showMatchAmmend:
        return content_match(content_ammend())
      default:
        return content_match(content_scoring_rt())
    }
  }

}

export default MatchScoreButtons